import { createStorageSlot } from '@gonfalon/browser-storage/createStorageSlot';
import {
  accountId,
  isSandbox as isSandboxConstantFunction,
  sandboxVisitorAccountId,
  sandboxVisitorMemberId,
  userId,
} from '@gonfalon/constants/constants';
import { waitForDogfoodClient } from '@gonfalon/dogfood-client/waitForDogfoodClient';
import {
  isAnalyticsTrackingEnabled,
  shouldSendFrontEndTrackEventsToCatfood,
} from '@gonfalon/dogfood-flags/dogfood-flags';

import { EVENT_ORIGIN_CLIENT, EVENT_ORIGIN_KEY } from './eventOrigin';
import { getExperimentProps } from './internal/getExperimentProps';
import { getUTMParams } from './internal/getUTMParams';
import { shouldSuppressProductAnalytics } from './internal/suppressProductAnalytics';
import type { AnalyticEventData } from './types';

declare const window: Window & {
  analytics?: SegmentAnalytics.AnalyticsJS;
  FS?: {
    getCurrentSessionURL: (includeCompleteURL: boolean) => string;
  };
};

const track = (event: string, category?: string, attributes?: AnalyticEventData, metricValue?: number) => {
  if (shouldSuppressProductAnalytics()) {
    return;
  }

  const isSandbox = isSandboxConstantFunction();

  let sandboxProps = {};
  if (isSandbox) {
    sandboxProps = {
      sandboxGuestEmail: createStorageSlot('sandboxGuestEmail').get(),
      sandboxVisitorAccountId: sandboxVisitorAccountId(),
      sandboxVisitorMemberId: sandboxVisitorMemberId(),
    };
  }

  if (isAnalyticsTrackingEnabled()) {
    window.analytics?.track?.(
      event,
      {
        category,
        userId: userId(),
        accountId: accountId(),
        isSandbox,
        ...getUTMParams(),
        ...sandboxProps,
        ...attributes,
        ...getExperimentProps(),
        [EVENT_ORIGIN_KEY]: EVENT_ORIGIN_CLIENT,
      },
      {
        integrations: {
          Intercom: false,
          Amplitude: { session_id: window.sessionStorage.getItem('sessionStartTime') },
        },
      },
    );
  }
  if (shouldSendFrontEndTrackEventsToCatfood()) {
    waitForDogfoodClient().then(
      (d) =>
        d.track(
          event,
          { ...attributes, ...getExperimentProps(), [EVENT_ORIGIN_KEY]: EVENT_ORIGIN_CLIENT },
          metricValue,
        ),
      // TODO: Switch to new logger package when it's ready
      // () => logger.error('Catfood tracking failed'),
      // oxlint-disable-next-line no-console
      () => console.error('Catfood tracking failed'),
    );
  }
};

export { track };
